import React, { useEffect, useRef, useState } from 'react';

// A menu that opens on click and closes on the next click outside it, or on
// Escape. It replaces a CSS hover-only pattern that left a small gap between
// the button and the panel: the menu disappeared as the pointer crossed the
// gap, so nothing inside it could ever be clicked.
const DropdownMenu = ({ trigger, align = 'right', children }) => {
  const [open, setOpen] = useState(false);
  const wrapper = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const closeOnOutsideClick = (event) => {
      if (!wrapper.current?.contains(event.target)) setOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };

    document.addEventListener('mousedown', closeOnOutsideClick);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('mousedown', closeOnOutsideClick);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [open]);

  return (
    <div className="relative" ref={wrapper}>
      {trigger({ open, toggle: () => setOpen((wasOpen) => !wasOpen) })}
      {open && (
        <div
          className={`absolute top-full ${align === 'right' ? 'right-0' : 'left-0'} z-50 mt-1 min-w-[12rem] rounded-lg border border-gray-200 bg-white py-1 shadow-lg`}
          onClick={() => setOpen(false)}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
